<template>
  <v-container fluid grid-list-sm>
    <v-layout>
      <template>
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="2500">
          {{ snackbarText }}
          <template v-slot:action="{ attrs }">
            <v-divider vertical></v-divider>
            <v-btn
              :color="snackbarColor === 'error' ? 'white' : 'bolsa-green'"
              text
              @click="snackbar = false"
              >Cerrar</v-btn
            >
          </template>
        </v-snackbar>

        <v-row justify="center">
          <v-dialog
            v-model="dialog"
            :fullscreen="$vuetify.breakpoint.smAndDown"
            :hide-overlay="$vuetify.breakpoint.smAndDown"
            transition="dialog-bottom-transition"
            class="scrollPage"
            width="70%"
          >
            <v-card>
              <!-- FILTRO -->
              <v-card-title class="pa-0">
                <v-toolbar dark color="bolsa-green">
                  <v-btn icon dark @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title>Filtrar</v-toolbar-title>
                  <div class="flex-grow-1"></div>
                  <v-toolbar-items>
                    <v-btn dark text @click="cleanFilters">
                      <v-icon>mdi-refresh</v-icon>Limpiar
                    </v-btn>
                    <v-btn dark text @click="setFilters">Guardar</v-btn>
                  </v-toolbar-items>
                </v-toolbar>
              </v-card-title>

              <v-card-text style="height: 80vh; overflow-y: scroll">
                <v-list three-line>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Rango Salarial</v-list-item-title>
                      <v-list-item-subtitle
                        >Puedes ajustar los resultados en función a la
                        retribución monetaria que deseas</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-range-slider
                        v-model="filters.range"
                        :max="max"
                        :min="min"
                        step="50"
                        hide-details
                        class="align-center"
                        color="bolsa-green"
                      >
                        <template v-slot:prepend>
                          <v-text-field
                            id="minRange"
                            v-model="filters.range[0]"
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="number"
                            style="width: 80px"
                            prefix="S/"
                          ></v-text-field>
                        </template>
                        <template v-slot:append>
                          <v-text-field
                            id="maxRange"
                            v-model="filters.range[1]"
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="number"
                            style="width: 80px"
                            prefix="S/"
                          ></v-text-field>
                        </template>
                      </v-range-slider>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>De las Empresas</v-list-item-title>
                      <v-list-item-subtitle
                        >Puedes elegir diferentes características sobre los
                        trabajos ofertados</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-select
                        v-model="filters.sectorSelecFiltro"
                        :items="getListaIndustrias"
                        item-text="nombre"
                        item-value="codigo"
                        menu-props="auto"
                        label="Sector Económico de la Empresa"
                        class="mx-2"
                        clearable
                      ></v-select>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-list three-line subheader>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title
                        >De los Requerimientos</v-list-item-title
                      >
                      <v-list-item-subtitle
                        >Puedes elegir entre los diferentes tipos de
                        requerimientos que se solicitan</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-select
                        v-model="filters.experienciaSelec"
                        :items="experienciaList"
                        item-text="text"
                        item-value="value"
                        menu-props="auto"
                        label="Experiencia"
                        class="mx-2"
                      ></v-select>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-select
                        v-model="filters.gradoAcademicoSelec"
                        :items="tiposAlum"
                        menu-props="auto"
                        label="Grado Académico"
                        class="mx-2"
                      ></v-select>
                      <v-select
                        v-model="filters.disponibilidadSelecFiltro"
                        :items="disponibilidad"
                        item-text="text"
                        item-value="value"
                        menu-props="auto"
                        label="Disponibilidad"
                        class="mx-2"
                      ></v-select>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
    </v-layout>
    <v-layout wrap column>
      <v-flex d-flex xs12 align-content-center>
        <v-flex
          xs12
          sm12
          md4
          v-show="
            Object.keys(this.idJobSelected).length === 0 ||
            this.$vuetify.breakpoint.mdAndUp
          "
          shrink
          column
        >
          <v-card elevation="4" :loading="loading" :disabled="disabled">
            <v-container fluid class="pb-0">
              <v-layout row wrap>
                <v-flex sm9 class="d-flex justify-start">
                  <h5
                    class="text-center font-weight-light text-md-left"
                    v-if="getUserInfo.carrera"
                  >
                    Trabajos para {{ getUserInfo.carrera.nombreEspecialidad }}
                  </h5>
                  <v-progress-circular
                    v-else
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-flex>
                <v-flex sm3 class="d-flex justify-end">
                  <h5
                    class="
                      text-center text-md-right
                      font-weight-light
                      text-truncate
                    "
                  >
                    {{ getJobData.length }} resultado(s)
                  </h5>
                </v-flex>
              </v-layout>
              <div class="py-2">
                <v-btn
                  block
                  color="bolsa-green"
                  :outlined="!isFiltered"
                  :dark="isFiltered"
                  :disabled="fetching"
                  @click="dialog = true"
                >
                  Filtrar Resultados
                  <v-icon right dark>mdi-filter</v-icon>
                </v-btn>
              </div>
            </v-container>
            <v-card-text
              class="pa-0"
              style="overflow-y: scroll"
              :style="
                $vuetify.breakpoint.lgAndDown ? 'height: 76vh' : 'height:84vh'
              "
            >
              <div class="d-flex flex-wrap">
                <v-list
                  three-line
                  class="py-0"
                  style="overflow-x: hidden; max-height: 100%; width: 100vw"
                >
                  <!-- lista Trabajos -->
                  <v-list-item-group
                    v-model="selected"
                    active-class="blue--text"
                  >
                    <template v-for="(item, index) in getJobData">
                      <v-list-item
                        :key="item._id"
                        dense
                        @click="changeJob(item._id, index)"
                      >
                        <template v-slot:default="{}">
                          <v-list-item-avatar left size="52">
                            <img
                              :src="item.idEmpresa.logo"
                              style="min-width: 100%; height: auto"
                              :alt="item.idEmpresa.nombreEmpresa"
                            />
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title
                              v-text="item.idEmpresa.nombreEmpresa"
                            ></v-list-item-title>
                            <v-list-item-subtitle
                              class="text--primary"
                              v-text="item.nombrePuesto"
                            ></v-list-item-subtitle>
                            <v-list-item-subtitle v-if="item.ubigeoNombre"
                              >{{
                                item.ubigeoNombre.departamento
                                  ? item.ubigeoNombre.departamento
                                      .toLowerCase()
                                      .replace(/^\w/, (c) => c.toUpperCase()) +
                                    ', '
                                  : ''
                              }}{{
                                item.ubigeoNombre.provincia
                                  ? item.ubigeoNombre.provincia
                                      .toLowerCase()
                                      .replace(/^\w/, (c) => c.toUpperCase()) +
                                    ', '
                                  : ''
                              }}{{
                                item.ubigeoNombre.distrito
                                  ? item.ubigeoNombre.distrito
                                      .toLowerCase()
                                      .replace(/^\w/, (c) => c.toUpperCase())
                                  : ''
                              }}</v-list-item-subtitle
                            >
                          </v-list-item-content>
                          <template>
                            <v-list-item-action>
                              <v-list-item-action-text
                                v-text="
                                  'Hace ' +
                                  Math.floor(
                                    new DateDiff(
                                      Date.now(),
                                      new Date(item.fechaPublicacion)
                                    ).days()
                                  ) +
                                  'd'
                                "
                              ></v-list-item-action-text>
                              <v-icon v-if="item.favorito" color="bolsa-green"
                                >mdi-star</v-icon
                              >
                              <v-icon v-else color="grey"
                                >mdi-star-outline</v-icon
                              >
                            </v-list-item-action>
                          </template>
                        </template>
                      </v-list-item>
                      <v-divider
                        v-if="index + 1 < jobList.length"
                        :key="index"
                      ></v-divider>
                    </template>
                  </v-list-item-group>
                </v-list>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex
          d-flex
          xs12
          sm12
          md8
          column
          shrink
          v-show="
            $vuetify.breakpoint.mdAndUp || Object.keys(idJobSelected).length
          "
          id="detalleTrabajo"
        >
          <v-card style="width: 100%" v-if="Object.keys(idJobSelected).length">
            <detalles-trabajo
              v-bind:data-empresa="this.idJobSelected"
              @btnRetorno="returnAction"
              @saveJob="changeJobSavedState"
              @applyJob="setApplyJob"
            ></detalles-trabajo>
          </v-card>
          <v-card
            v-show="
              Object.keys(idJobSelected).length === 0 &&
              $vuetify.breakpoint.mdAndUp
            "
            color="white"
            min-width="100%"
            :loading="loadingDetail"
          >
            <v-card-text style="height: 100%">
              <v-container bg fill-height text-xs-center>
                <v-row align="center" justify="center">
                  <v-col v-if="!this.getError.error">
                    <p class="text-center overline" v-if="!loadingDetail">
                      Selecciona un elemento en el panel izquierdo para comenzar
                    </p>
                  </v-col>
                  <v-col
                    class="d-flex justify-center align-center flex-column"
                    v-else
                  >
                    <v-icon size="90" color="red" class="mb-4"
                      >mdi-lan-disconnect</v-icon
                    >
                    <p class="subtitle-2" style="color: red">
                      Un error ha ocurrido, intenta recargando la página.
                    </p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DetallesTrabajo from '@/components/user/DetalleTrabajo.vue'
import DateDiff from 'date-diff'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    DetallesTrabajo,
    DateDiff
  },
  data: function () {
    return {
      DateDiff: DateDiff,
      loading: 'bolsa-green',
      disabled: false,
      loadingDetail: false,
      dialog: false,
      notifications: false,
      sound: true,
      snackbarText: '',
      snackbar: false,
      widgets: false,
      min: 950,
      max: 18000,
      slider: 50,
      range: [950, 18000],
      funcionesSelec: [],
      conocimientosSelec: [],
      conocimientosList: [],
      experienciaSelec: [],
      experienciaList: [
        {
          text: 'Menos de 1 año',
          value: 1
        },
        {
          text: 'Entre 1 a 3 años',
          value: 2
        },
        {
          text: 'Más de 3 años',
          value: 3
        }
      ],
      tipoAlumSelec: 'Cualquiera',
      tiposAlum: [
        'Estudiante',
        'Egresado',
        'Bachiller',
        'Licenciado',
        'Titulado',
        'Maestría',
        'Doctorado',
        'Ph. D.'
      ],
      idJobSelected: {},
      selectedIndex: 0,
      selected: [0],
      jobList: [],
      snackbarColor: '',
      especialidadesSelecFiltro: [],
      especialidades: [
        'Arquitectura',
        'Ingeniería Física',
        'Química',
        'Física',
        'Matemática',
        'Ciencias de la Computación',
        'Ingeniería Sanitaria',
        'Ingeniería de Higiene y Seguridad Industrial',
        'Ingeniería Ambiental',
        'Ingeniería Civil',
        'Ingeniería Económica',
        'Ingeniería Estadística',
        'Ingeniería Eléctrica',
        'Ingeniería Electrónica',
        'Ingeniería de Telecomunicaciones',
        'Ingeniería de Minas',
        'Ingeniería Geológica',
        'Ingeniería Metalúrgica',
        'Ingeniería Industrial',
        'Ingeniería de Sistemas',
        'Ingeniería Mecánica',
        'Ingeniería Mecánica-Eléctrica',
        'Ingeniería Naval',
        'Ingeniería Mecatrónica',
        'Ingeniería de Petróleo',
        'Ingeniería Petroquímica',
        'Ingeniería Química',
        'Ingeniería Textil'
      ],
      ubicaciones: [],
      sectorEconomico: [
        'Construcción',
        'Telecomunicaciones',
        'Consultoría',
        'Banca'
      ],
      disponibilidad: [
        {
          text: 'Tiempo Parcial',
          value: 1
        },
        {
          text: 'Tiempo Completo',
          value: 2
        }
      ],
      filters: {
        range: [950, 18000],
        sectorSelecFiltro: '',
        experienciaSelec: '',
        gradoAcademicoSelec: '',
        disponibilidadSelecFiltro: ''
      },
      isFiltered: false,
      jobsFiltered: []
    }
  },
  methods: {
    changeJob: async function (id, index) {
      this.idJobSelected = {}
      this.disabled = true
      this.selectedIndex = index
      this.loadingDetail = 'bolsa-green'
      this.idJobSelected = await this.getJobById(id)
      this.selectedIsSaved = this.idJobSelected.favorito
      this.disabled = this.loadingDetail = false
    },
    returnAction: function (value) {
      this.idJobSelected = value
    },
    changeJobSavedState: function (isSaved, getError) {
      if (!getError.error) {
        this.snackbarColor = getError.errorMessage
        this.snackbarText = isSaved
          ? 'Se Guardó En Favoritos'
          : 'Se Quitó De Favoritos'
        this.snackbar = true
        this.jobList[this.selectedIndex].favorito = isSaved
      } else {
        this.snackbarColor = 'error'
        this.snackbarText = getError.errorMessage
        this.snackbar = true
      }
    },
    setApplyJob: function (isApplying, getError) {
      if (!getError.error) {
        this.snackbarColor = getError.errorMessage
        this.snackbarText = isApplying
          ? 'Ahora estás postulando!'
          : 'Ya no estás postulando'
        this.snackbar = true
      } else {
        this.snackbarColor = 'error'
        this.snackbarText = getError.errorMessage
        this.snackbar = true
      }
    },

    cleanFilters: function () {
      this.filters = {
        range: [950, 18000],
        sectorSelecFiltro: '',
        experienciaSelec: '',
        gradoAcademicoSelec: '',
        disponibilidadSelecFiltro: ''
      }
      this.isFiltered = false
      this.dialog = false
    },

    setFilters: function () {
      let arrFilter = []
      let filtered = false
      if (
        this.filters.range[0] != 950 ||
        this.filters.range[1] != 18000 ||
        this.filters.sectorSelecFiltro != '' ||
        this.filters.experienciaSelec != '' ||
        this.filters.gradoAcademicoSelec != '' ||
        this.filters.disponibilidadSelecFiltro != ''
      ) {
        if (this.filters.range[0] != 950) {
          arrFilter = this.jobList.filter((item) => {
            if (item.salario.tipo == 'RANGO') {
              return item.salario.valor.minimo >= this.filters.range[0]
            } else if (item.salario.tipo == 'FIJO') {
              return item.salario.valor >= this.filters.range[0]
            }
          })
          filtered = true
        }

        if (this.filters.range[1] != 18000) {
          arrFilter = filtered
            ? arrFilter.filter((item) => {
                if (item.salario.tipo == 'RANGO') {
                  return item.salario.valor.maximo <= this.filters.range[1]
                } else if (item.salario.tipo == 'FIJO') {
                  return item.salario.valor <= this.filters.range[1]
                }
              })
            : this.jobList.filter((item) => {
                if (item.salario.tipo == 'RANGO') {
                  return item.salario.valor.maximo <= this.filters.range[1]
                } else if (item.salario.tipo == 'FIJO') {
                  return item.salario.valor <= this.filters.range[1]
                }
              })
          filtered = true
        }

        if (this.filters.sectorSelecFiltro !== '') {
          arrFilter = filtered
            ? arrFilter.filter(
                (item) =>
                  item.idEmpresa.sectorIndustrial ==
                  this.filters.sectorSelecFiltro
              )
            : this.jobList.filter(
                (item) =>
                  item.idEmpresa.sectorIndustrial ==
                  this.filters.sectorSelecFiltro
              )
          filtered = true
        }

        if (this.filters.experienciaSelec !== '') {
          let isReturned = false
          arrFilter = filtered
            ? arrFilter.filter((item) => {
                if (item.experiencia.some((value) => value.unidad != 'AÑOS')) {
                  return this.filters.experienciaSelec == 1
                } else {
                  switch (this.filters.experienciaSelec) {
                    case 2:
                      isReturned = this.experiencia.some(
                        (value) => value.tiempo >= 1 && value.tiempo <= 3
                      )
                      break

                    case 3:
                      isReturned = this.experiencia.some(
                        (value) => value.tiempo >= 3
                      )
                      break

                    default:
                      break
                  }
                  return isReturned
                }
              })
            : this.jobList.filter((item) => {
                if (item.experiencia.some((value) => value.unidad != 'AÑOS')) {
                  return this.filters.experienciaSelec == 1
                } else {
                  switch (this.filters.experienciaSelec) {
                    case 2:
                      isReturned = this.experiencia.some(
                        (value) => value.tiempo >= 1 && value.tiempo <= 3
                      )
                      break

                    case 3:
                      isReturned = this.experiencia.some(
                        (value) => value.tiempo >= 3
                      )
                      break

                    default:
                      break
                  }
                  return isReturned
                }
              })

          filtered = true
        }

        if (this.filters.gradoAcademicoSelec !== '') {
          arrFilter = filtered
            ? arrFilter.filter((item) =>
                item.gradoAcademico.some(
                  (value) => value == this.filters.gradoAcademicoSelec
                )
              )
            : this.jobList.filter((item) =>
                item.gradoAcademico.some(
                  (value) => value == this.filters.gradoAcademicoSelec
                )
              )

          filtered = true
        }

        if (this.filters.disponibilidadSelecFiltro !== '') {
          arrFilter = filtered
            ? arrFilter.filter((item) => {
                if (this.filters.disponibilidadSelecFiltro == 1) {
                  return item.horario.horasSemanales <= 30
                } else if (this.filters.disponibilidadSelecFiltro == 2) {
                  return item.horario.horasSemanales > 30
                }
              })
            : this.jobList.filter((item) => {
                if (this.filters.disponibilidadSelecFiltro == 1) {
                  return item.horario.horasSemanales <= 30
                } else if (this.filters.disponibilidadSelecFiltro == 2) {
                  return item.horario.horasSemanales > 30
                }
              })

          filtered = true
        }

        this.isFiltered = true
        this.jobsFiltered = arrFilter
      } else {
        this.isFiltered = false
      }
      this.dialog = false
    },

    ...mapActions('user', ['getJobList', 'getJobById'])
  },
  computed: {
    getJobData() {
      if (this.isFiltered) return this.jobsFiltered
      else return this.jobList
    },

    ...mapGetters('user', [
      'getError',
      'getListaCarreras',
      'getListaIndustrias',
      'fetching',
      'getUserInfo'
    ])
  },
  async mounted() {
    const jobs = await this.getJobList()
    this.jobList = jobs || []
    this.loading = false
    if (this.getError.error) {
      this.loading = '#711610'
      this.snackbar = this.getError.error
      this.snackbarText = this.getError.errorMessage
    }
  }
}
</script>

<style scoped>
.scrollPage {
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: rgba(245, 245, 245, 0.15);
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: rgba(245, 245, 245, 0.15);
}

::-webkit-scrollbar {
  width: 8px;
  background-color: rgba(245, 245, 245, 0.308);
}

::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  background-color: rgba(85, 85, 85, 0.5);
}
</style>
